// @flow

import { useParams } from "react-router";
import { EditGradingServiceParameters } from "../components/Schemas/EditGradingServiceParameters";

export const EditGradingServiceParametersPage = () => {
  let { id } = useParams();

  const c = {
    schemaTreeId: parseInt(id ?? ""),
    // make sure all required component's inputs/Props keys&types match
  };
  return <EditGradingServiceParameters {...c} />;
};
